module.exports = __webpack_public_path__ + "img/home-map.336e23c9.png";